/**
 * Global Filters Component Constants
 */

export const GLOBAL_FILTERS_CONSTANTS = {
  /** Height of the toggle buttons / dropdowns */
  CONTROL_HEIGHT: 36,
  /** Border radius for the pill-shaped controls (full pill = 30px) */
  TOGGLE_BORDER_RADIUS: 9999,
  /** Dropdown min width in theme spacing units */
  DROPDOWN_MIN_WIDTH: 62,
  /** Gap between filter controls in theme spacing units */
  GAP: 2,
} as const;

/**
 * Account type toggle values — i18n keys resolved at render time in the hook.
 */
export const TOGGLE_OPTION_VALUES = ['funded', 'payout', 'all'] as const;

export type AccountTypeValue = (typeof TOGGLE_OPTION_VALUES)[number];
